export class CaseFormModel {
    
    constructor(values?: Partial<CaseFormModel>) {
        Object.assign(this, values);
    }
    caseSysId: string = '';
    caseNumber: string = '';
    sys_id: string = '';
    u_locked_by_sso_id: string = '';
    u_last_locked_activity_time: string = '';
    number: string = '';
    description: string = '';
    short_description: string = '';
    urgency: string = '';
    u_case_type: string = 'USAN';
    u_suggested_names_in_order_of_preference_for_single_entity: string = '';
    u_name_for_which_you_are_requesting_a_revision: string = '';
    u_reason_for_revision: string = '';
    u_designation_for_salt_form: string = '';
    u_chemical_names_or_description_for_single_entity: string = '';
    u_chemical_names_or_description_for_salt_form: string = '';
    u_chemical_names_or_description: string = '';
    u_systematic_names_or_description: string = '';
    u_molecular_formula_for_single_entity: string = '';
    u_molecular_formula_for_salt_form: string = '';
    u_molecular_formula: string = '';
    u_molecular_weight_for_single_entity: string = '';
    u_molecular_weight_for_salt_form: string = '';
    u_molecular_weight: string = '';
    u_is_this_a_pro_drug: string = '';
    u_chemical_abstracts_service_cas_registry_number_for_single_entity!: string;
    u_chemical_abstracts_service_cas_registry_number_for_salt_form!: string;
    u_chemical_abstracts_service_cas_registry_number!: string;
    u_unique_ingredient_identifier_unii_number!: string;
    u_unique_ingredient_identifier_unii_number_salt!: string;
    u_indications_therapeutic_claim: string = '';
    u_code_designation_for_single_entity: string = '';
    u_code_designation_for_salt_form: string = '';
    u_code_designations: string = '';
    u_trademarks: string = '';
    u_trivial_names: string = '';
    u_manufacturers: string = '';
    u_principal_theraputic_uses: string = '';
    u_pharmacologic_action: string = '';
    u_does_the_substance_bind_to_a_receptor_enzyme_or_other_target: string = '';
    u_substance_bind_explanation: string = '';
    u_inn_submission: string = '';
    u_inn_submission_number: string = '';
    u_inn_submission_explanation: string = '';
    u_phase_1_clinical_trials_began_date: string = '';
    u_ind_application_numbers: string = '';
    u_submitted_by_first_name: string = '';
    u_submitted_by_last_name: string = '';
    u_signature: string = '';
    u_form_type: string = '';
    u_file_number_single_entity: string = '';
    u_file_number_modified: string = '';
    u_acknowledged: string = '';
    u_who_number: string = '';
    u_inn_status: string = '';
    u_usan_org_id: string = '';
    u_case_status: string = '';
    u_please_disclose_if_there_is_a_polymer_present: string = '';
    u_please_disclose_whether_a_semi_interpenetrating_network_is_formed: string = '';
    u_please_disclose_the_degreee_of_polymerization: string = '';
    u_list_the_formula_for_each_monomer_and_for_the_whole_polymer: string = '';
    u_chemicals_attached: string = '';
    u_manufacturing_process: string = '';
    u_purity_of_2_hydroxyethyl_methacrylate_if_applicable: string = '';
    u_water_content_at_ambient_temperature_23_2_c: string = '';
    u_water_content: string = '';
    u_mean_value_standard_deviation_water_content!: string;
    u_number_of_measurements_water_content!: string;
    u_oxygen_permeability_at_35_c: string = '';
    u_oxygen_permeability: string = '';
    u_mean_value_standard_deviation_oxygen!: string;
    u_number_of_measurements_oxygen!: string;
    u_method_used_to_determine_oxygen_permeability: string = '';
    u_usan_user_sso_id: string = '';
    u_usan_user_firstname: string = '';
    u_usan_user_lastname: string = '';
    u_usan_user_email: string = '';
    u_usan_applicant_sso_id: string = '';
    u_usan_applicant_firstname: string = '';
    u_usan_applicant_lastname: string = '';
    u_usan_applicant_email: string = '';
    u_applicant: string = '';
    u_usan_collaborator_1_sso_id: string = '';
    u_usan_collaborator_1_first_name: string = '';
    u_usan_collaborator_1_last_name: string = '';
    u_usan_collaborator_1_email: string = '';
    u_usan_collaborator_2_sso_id: string = '';
    u_usan_collaborator_2_first_name: string = '';
    u_usan_collaborator_2_last_name: string = '';
    u_usan_collaborator_2_email: string = '';
    u_address!: string;
    u_street_1: string = '';
    u_street_2: string = '';
    u_city: string = '';
    u_state: string = '';
    u_postal_code: string = '';
    u_country: string = '';
    u_telephone_number: string = '';
    u_telephone_type: string = '';
    u_primary_contact_first_name: string = '';
    u_primary_contact_last_name: string = '';
    u_pronoun: string = '';
    u_title: string = '';
    u_email_address: string = '';
    u_payment_type: string = '';
    u_payment_status: string = '';
    u_payment_amount: number = 0.00;
    u_payment_date: string = '';
    u_order_id: string = '';
    u_trans_id: string = '';
    u_auth_cd: string = '';
    u_application_submitted_date: string = '';

    public static parseValues(json: any) {
        if(!json) {
            return new CaseFormModel();
        }
        const caseNumber = json.caseNumber ? json.caseNumber : (json.number ? json.number : null);
        const formType = json.u_form_type ? json.u_form_type.replace(/\s+/g, '') : json.u_form_type; // removes all whitespace without npe
        const proDrug = (json.u_is_this_a_pro_drug == 'Yes' || json.u_is_this_a_pro_drug == 'No') ? json.u_is_this_a_pro_drug : null;
        const substanceBinds = (json.u_does_the_substance_bind_to_a_receptor_enzyme_or_other_target == 'Yes' || json.u_does_the_substance_bind_to_a_receptor_enzyme_or_other_target == 'No') ? json.u_does_the_substance_bind_to_a_receptor_enzyme_or_other_target : null;
        const responseDetails = {
            caseSysId: json.caseSysId,
            caseNumber: caseNumber,
            sys_id: json.sys_id,
            u_locked_by_sso_id: json.u_locked_by_sso_id,
            u_last_locked_activity_time: json.u_last_locked_activity_time,
            description: json.description,
            short_description: json.short_description,
            urgency: json.urgency,
            u_case_type: json.u_case_type,
            u_suggested_names_in_order_of_preference_for_single_entity: json.u_suggested_names_in_order_of_preference_for_single_entity,
            u_name_for_which_you_are_requesting_a_revision: json.u_name_for_which_you_are_requesting_a_revision,
            u_reason_for_revision: json.u_reason_for_revision,
            u_designation_for_salt_form: json.u_designation_for_salt_form,
            u_chemical_names_or_description_for_single_entity: json.u_chemical_names_or_description_for_single_entity,
            u_chemical_names_or_description_for_salt_form: json.u_chemical_names_or_description_for_salt_form,
            u_chemical_names_or_description: json.u_chemical_names_or_description,
            u_systematic_names_or_description: json.u_systematic_names_or_description,
            u_molecular_formula_for_single_entity: json.u_molecular_formula_for_single_entity,
            u_molecular_formula_for_salt_form: json.u_molecular_formula_for_salt_form,
            u_molecular_formula: json.u_molecular_formula,
            u_molecular_weight_for_single_entity: json.u_molecular_weight_for_single_entity,
            u_molecular_weight_for_salt_form: json.u_molecular_weight_for_salt_form,
            u_molecular_weight: json.u_molecular_weight,
            u_is_this_a_pro_drug: proDrug,
            u_chemical_abstracts_service_cas_registry_number_for_single_entity: json.u_chemical_abstracts_service_cas_registry_number_for_single_entity,
            u_chemical_abstracts_service_cas_registry_number_for_salt_form: json.u_chemical_abstracts_service_cas_registry_number_for_salt_form,
            u_chemical_abstracts_service_cas_registry_number: json.u_chemical_abstracts_service_cas_registry_number,
            u_unique_ingredient_identifier_unii_number: json.u_unique_ingredient_identifier_unii_number,
            u_unique_ingredient_identifier_unii_number_salt: json.u_unique_ingredient_identifier_unii_number_salt,
            u_code_designation_for_single_entity: json.u_code_designation_for_single_entity,
            u_code_designation_for_salt_form: json.u_code_designation_for_salt_form,
            u_code_designations: json.u_code_designations,
            u_trademarks: json.u_trademarks,
            u_trivial_names: json.u_trivial_names,
            u_manufacturers: json.u_manufacturers,
            u_principal_theraputic_uses: json.u_principal_theraputic_uses,
            u_pharmacologic_action: json.u_pharmacologic_action,
            u_does_the_substance_bind_to_a_receptor_enzyme_or_other_target: substanceBinds,
            u_substance_bind_explanation: json.u_substance_bind_explanation,
            u_inn_submission: json.u_inn_submission,
            u_inn_submission_number: json.u_inn_submission_number,
            u_inn_submission_explanation: json.u_inn_submission_explanation,
            u_indications_therapeutic_claim:json.u_indications_therapeutic_claim,
            u_phase_1_clinical_trials_began_date: json.u_phase_1_clinical_trials_began_date,
            u_ind_application_numbers: json.u_ind_application_numbers,
            u_submitted_by_first_name: json.u_submitted_by_first_name,
            u_submitted_by_last_name: json.u_submitted_by_last_name,
            u_signature: json.u_signature,
            u_form_type: formType,
            u_file_number_single_entity: json.u_file_number_single_entity,
            u_file_number_modified: json.u_file_number_modified,
            u_acknowledged: json.u_acknowledged,
            u_who_number: json.u_who_number,
            u_inn_status: json.u_inn_status,
            u_usan_org_id: json.u_usan_org_id,
            u_case_status: json.u_case_status,
            u_please_disclose_if_there_is_a_polymer_present: json.u_please_disclose_if_there_is_a_polymer_present,
            u_please_disclose_whether_a_semi_interpenetrating_network_is_formed: json.u_please_disclose_whether_a_semi_interpenetrating_network_is_formed,
            u_please_disclose_the_degreee_of_polymerization: json.u_please_disclose_the_degreee_of_polymerization,
            u_list_the_formula_for_each_monomer_and_for_the_whole_polymer: json.u_list_the_formula_for_each_monomer_and_for_the_whole_polymer,
            u_chemicals_attached: json.u_chemicals_attached,
            u_manufacturing_process: json.u_manufacturing_process,
            u_purity_of_2_hydroxyethyl_methacrylate_if_applicable: json.u_purity_of_2_hydroxyethyl_methacrylate_if_applicable,
            u_water_content_at_ambient_temperature_23_2_c: json.u_water_content_at_ambient_temperature_23_2_c,
            u_water_content: json.u_water_content,
            u_mean_value_standard_deviation_water_content: json.u_mean_value_standard_deviation_water_content,
            u_number_of_measurements_water_content: json.u_number_of_measurements_water_content,
            u_oxygen_permeability_at_35_c: json.u_oxygen_permeability_at_35_c,
            u_oxygen_permeability: json.u_oxygen_permeability,
            u_mean_value_standard_deviation_oxygen: json.u_mean_value_standard_deviation_oxygen,
            u_number_of_measurements_oxygen: json.u_number_of_measurements_oxygen,
            u_method_used_to_determine_oxygen_permeability: json.u_method_used_to_determine_oxygen_permeability,
            u_usan_user_sso_id: json.u_usan_user_sso_id,
            u_usan_user_firstname: json.u_usan_user_firstname,
            u_usan_user_lastname: json.u_usan_user_lastname,
            u_usan_user_email: json.u_usan_user_email,
            u_usan_applicant_sso_id: json.u_usan_applicant_sso_id,
            u_usan_applicant_firstname: json.u_usan_applicant_firstname,
            u_usan_applicant_lastname: json.u_usan_applicant_lastname,
            u_usan_applicant_email: json.u_usan_applicant_email,
            u_applicant: json.u_applicant,
            u_usan_collaborator_1_sso_id: json.u_usan_collaborator_1_sso_id,
            u_usan_collaborator_1_last_name: json.u_usan_collaborator_1_last_name,
            u_usan_collaborator_1_first_name: json.u_usan_collaborator_1_first_name,
            u_usan_collaborator_1_email: json.u_usan_collaborator_1_email,
            u_usan_collaborator_2_sso_id: json.u_usan_collaborator_2_sso_id,
            u_usan_collaborator_2_first_name: json.u_usan_collaborator_2_first_name,
            u_usan_collaborator_2_last_name: json.u_usan_collaborator_2_last_name,
            u_usan_collaborator_2_email: json.u_usan_collaborator_2_email,
            u_address: json.u_address,
            u_street_1: json.u_street_1,
            u_street_2: json.u_street_2,
            u_city: json.u_city,
            u_state: json.u_state,
            u_postal_code: json.u_postal_code,
            u_country: json.u_country,
            u_telephone_number: json.u_telephone_number,
            u_telephone_type: json.u_telephone_type,
            u_primary_contact_first_name: json.u_primary_contact_first_name,
            u_primary_contact_last_name: json.u_primary_contact_last_name,
            u_pronoun: json.u_pronoun,
            u_title: json.u_title,
            u_email_address: json.u_email_address,
            u_payment_type: json.u_payment_type,
            u_payment_status: json.u_payment_status,
            u_payment_amount: json.u_payment_amount,
            u_payment_date: json.u_payment_date,
            u_order_id: json.u_order_id,
            u_trans_id: json.u_trans_id,
            u_auth_cd: json.u_auth_cd,
            u_application_submitted_date: json.u_application_submitted_date
        };

        return new CaseFormModel(responseDetails);
    }

}
